import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.admin.uploadlog');
import { OnInit, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-admin-uploadlog',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.admin.uploadlog/view.scss */
:host {
  display: block;
  width: 100%;
}`],
})
export class PortalAdminUploadlogComponent implements OnInit, OnDestroy {
    constructor(@Inject( Service) public service: Service) { }

    public logs: any[] = [];
    public logTotal: number = 0;
    public logPage: number = 1;
    public logDump: number = 20;
    public logLoading: boolean = false;
    public filterType: string = '';

    // 상세 모달
    public detailOpen: boolean = false;
    public detailLoading: boolean = false;
    public detailData: any = null;

    // 전체 삭제 모달
    public purgeModalOpen: boolean = false;
    public purgePassword: string = '';
    public purging: boolean = false;
    public purgeError: string = '';

    // publication_keyword 재생성
    public rebuildingPK: boolean = false;
    public rebuildPKProgress: any = null;
    private rebuildPKPollTimer: any = null;

    // 연구자 통계 재가공
    public rebuildingStats: boolean = false;
    public rebuildStatsProgress: any = null;
    private rebuildStatsPollTimer: any = null;


    public async ngOnInit() {
        await this.service.init();
        await this.loadLogs();
        await this.service.render();
    }

    private apiUrl(fn: string) {
        return `/wiz/api/page.admin/${fn}`;
    }

    private async readJson(resp: Response): Promise<any> {
        const contentType = resp.headers.get('content-type') || '';
        if (!contentType.includes('application/json')) {
            throw new Error(resp.redirected ? '인증이 만료되었습니다.' : `JSON 응답이 아닙니다. (${resp.status})`);
        }
        return await resp.json();
    }

    // ── 업로드 이력 ────────────────────────────────────────
    public async loadLogs() {
        this.logLoading = true;
        await this.service.render();
        try {
            const form = new FormData();
            form.append('data_type', this.filterType);
            form.append('page', String(this.logPage));
            form.append('dump', String(this.logDump));
            const resp = await fetch(this.apiUrl('upload_logs'), {
                method: 'POST',
                body: form,
                credentials: 'include',
            });
            const json = await this.readJson(resp);
            if (json?.code === 200) {
                this.logs = json.data?.rows || [];
                this.logTotal = json.data?.total || 0;
            } else if (json?.code === 401) {
                window.location.href = '/signup';
            } else {
                this.logs = [];
                this.logTotal = 0;
            }
        } catch (e) {
            this.logs = [];
            this.logTotal = 0;
        }
        this.logLoading = false;
        await this.service.render();
    }

    public get logTotalPages(): number {
        return Math.max(1, Math.ceil(this.logTotal / this.logDump));
    }

    public async goLogPage(page: number) {
        if (page < 1 || page > this.logTotalPages) return;
        this.logPage = page;
        await this.loadLogs();
    }

    public async setFilter(type: string) {
        this.filterType = type;
        this.logPage = 1;
        await this.loadLogs();
    }

    // ── 상세 모달 ────────────────────────────────────────
    public async openDetail(log: any) {
        this.detailOpen = true;
        this.detailLoading = true;
        this.detailData = null;
        await this.service.render();

        try {
            const form = new FormData();
            form.append('log_id', String(log.id));
            const resp = await fetch(this.apiUrl('upload_log_detail'), {
                method: 'POST',
                body: form,
                credentials: 'include',
            });
            const json = await this.readJson(resp);
            if (json?.code === 200) {
                this.detailData = json.data?.data || json.data;
            } else if (json?.code === 401) {
                window.location.href = '/signup';
            }
        } catch (e) {
            this.detailData = null;
        }
        this.detailLoading = false;
        await this.service.render();
    }

    public async closeDetail() {
        this.detailOpen = false;
        this.detailData = null;
        await this.service.render();
    }

    public get detailErrors(): any[] {
        if (!this.detailData?.message_data) return [];
        const md = this.detailData.message_data;
        const direct = md.errors || [];
        if (direct.length > 0) return direct;
        if (md.files && Array.isArray(md.files)) {
            const collected: any[] = [];
            for (const f of md.files) {
                if (f.errors && Array.isArray(f.errors)) {
                    collected.push(...f.errors);
                }
            }
            if (collected.length > 0) return collected;
        }
        return [];
    }

    public get detailSummary(): any {
        if (!this.detailData?.message_data) return null;
        return this.detailData.message_data;
    }

    public get detailMessageText(): string {
        if (!this.detailData?.message_data) return this.detailData?.message || '';
        const md = this.detailData.message_data;
        if (md.text) return md.text;
        return '';
    }

    // ── 전체 삭제 ────────────────────────────────────────
    public async openPurgeModal() {
        this.purgeModalOpen = true;
        this.purgePassword = '';
        this.purgeError = '';
        await this.service.render();
    }

    public async closePurgeModal() {
        this.purgeModalOpen = false;
        this.purgePassword = '';
        this.purgeError = '';
        await this.service.render();
    }

    public async executePurge() {
        if (!this.purgePassword) {
            this.purgeError = '비밀번호를 입력해주세요.';
            await this.service.render();
            return;
        }
        this.purging = true;
        this.purgeError = '';
        await this.service.render();
        try {
            const form = new FormData();
            form.append('password', this.purgePassword);
            const resp = await fetch(this.apiUrl('purge_tables'), {
                method: 'POST',
                body: form,
                credentials: 'include',
            });
            const json = await this.readJson(resp);
            if (json?.code === 200) {
                await this.closePurgeModal();
                await this.loadLogs();
            } else if (json?.code === 401) {
                window.location.href = '/signup';
            } else {
                this.purgeError = json?.data?.message || '삭제에 실패했습니다.';
            }
        } catch (e) {
            this.purgeError = '서버 오류가 발생했습니다.';
        }
        this.purging = false;
        await this.service.render();
    }

    // ── 블록 페이지네이션 ────────────────────────────────────────
    public get pageBlockSize(): number { return 10; }

    public get currentBlock(): number {
        return Math.floor((this.logPage - 1) / this.pageBlockSize);
    }

    public get blockStart(): number {
        return this.currentBlock * this.pageBlockSize + 1;
    }

    public get blockEnd(): number {
        return Math.min(this.blockStart + this.pageBlockSize - 1, this.logTotalPages);
    }

    public get blockPages(): number[] {
        const arr: number[] = [];
        for (let i = this.blockStart; i <= this.blockEnd; i++) arr.push(i);
        return arr;
    }

    public get hasPrevBlock(): boolean { return this.currentBlock > 0; }
    public get hasNextBlock(): boolean { return this.blockEnd < this.logTotalPages; }

    public async goPrevBlock() {
        const target = (this.currentBlock - 1) * this.pageBlockSize + 1;
        await this.goLogPage(target);
    }

    public async goNextBlock() {
        const target = this.blockEnd + 1;
        await this.goLogPage(target);
    }

    // ── publication_keyword 재생성 ────────────────────────
    public async rebuildPubKeyword() {
        if (this.rebuildingPK) return;
        if (!confirm('publication_keyword 테이블을 초기화하고 재생성합니다.\n데이터가 많으면 시간이 걸릴 수 있습니다. 진행하시겠습니까?')) return;

        this.rebuildingPK = true;
        this.rebuildPKProgress = { current: 0, total: 0, phase: 'starting' };
        await this.service.render();

        this.startRebuildPKPoll();

        try {
            const form = new FormData();
            const resp = await fetch(this.apiUrl('rebuild_pub_keyword'), {
                method: 'POST',
                body: form,
                credentials: 'include',
            });
            const json = await this.readJson(resp);
            if (json.code === 200) {
                this.rebuildPKProgress = { current: 1, total: 1, phase: 'done' };
            } else if (json?.code === 401) {
                window.location.href = '/signup';
            } else {
                alert('키워드 재생성 실패: ' + (json.data?.message || '알 수 없는 오류'));
            }
        } catch (e: any) {
            alert('키워드 재생성 중 오류: ' + e.message);
        }

        this.stopRebuildPKPoll();
        this.rebuildingPK = false;
        this.rebuildPKProgress = null;
        await this.service.render();
    }

    private startRebuildPKPoll() {
        this.stopRebuildPKPoll();
        this.rebuildPKPollTimer = setInterval(async () => {
            try {
                const resp = await fetch(this.apiUrl('rebuild_pub_keyword_progress'), {
                    method: 'POST',
                    credentials: 'include',
                });
                const json = await this.readJson(resp);
                if (json?.code === 200 && json.data?.data) {
                    this.rebuildPKProgress = json.data.data;
                    await this.service.render();
                } else if (json?.code === 401) {
                    window.location.href = '/signup';
                }
            } catch (e) { }
        }, 1000);
    }

    private stopRebuildPKPoll() {
        if (this.rebuildPKPollTimer) {
            clearInterval(this.rebuildPKPollTimer);
            this.rebuildPKPollTimer = null;
        }
    }

    public get rebuildPKProgressText(): string {
        if (!this.rebuildPKProgress) return '준비 중...';
        const { current, total, phase } = this.rebuildPKProgress;
        if (phase === 'starting' || phase === 'initializing') return '준비 중...';
        if (!total || total <= 0) return '준비 중...';
        const pct = Math.round((current / total) * 100);
        return `${(current || 0).toLocaleString()} / ${total.toLocaleString()}건 (${pct}%)`;
    }

    // ── 연구자 통계 재가공 ────────────────────────────────
    public async rebuildResearcherStats() {
        if (this.rebuildingStats) return;
        if (!confirm('연구자 통계 정보(논문/보고서/특허 수, 키워드, 좋아요)를 재가공합니다.\n데이터가 많으면 시간이 걸릴 수 있습니다. 진행하시겠습니까?')) return;

        this.rebuildingStats = true;
        this.rebuildStatsProgress = { current: 0, total: 0, phase: 'starting' };
        await this.service.render();

        this.startRebuildStatsPoll();

        try {
            const form = new FormData();
            const resp = await fetch(this.apiUrl('rebuild_researcher_stats'), {
                method: 'POST',
                body: form,
                credentials: 'include',
            });
            const json = await this.readJson(resp);
            if (json.code === 200) {
                this.rebuildStatsProgress = { current: 1, total: 1, phase: 'done' };
            } else if (json?.code === 401) {
                window.location.href = '/signup';
            } else {
                alert('연구자 통계 재가공 실패: ' + (json.data?.message || '알 수 없는 오류'));
            }
        } catch (e: any) {
            alert('연구자 통계 재가공 중 오류: ' + e.message);
        }

        this.stopRebuildStatsPoll();
        this.rebuildingStats = false;
        this.rebuildStatsProgress = null;
        await this.service.render();
    }

    private startRebuildStatsPoll() {
        this.stopRebuildStatsPoll();
        this.rebuildStatsPollTimer = setInterval(async () => {
            try {
                const resp = await fetch(this.apiUrl('rebuild_researcher_stats_progress'), {
                    method: 'POST',
                    credentials: 'include',
                });
                const json = await this.readJson(resp);
                if (json?.code === 200 && json.data?.data) {
                    this.rebuildStatsProgress = json.data.data;
                    await this.service.render();
                } else if (json?.code === 401) {
                    window.location.href = '/signup';
                }
            } catch (e) { }
        }, 1000);
    }

    private stopRebuildStatsPoll() {
        if (this.rebuildStatsPollTimer) {
            clearInterval(this.rebuildStatsPollTimer);
            this.rebuildStatsPollTimer = null;
        }
    }

    public get rebuildStatsProgressText(): string {
        if (!this.rebuildStatsProgress) return '준비 중...';
        const { current, total, phase } = this.rebuildStatsProgress;
        if (phase === 'starting' || phase === 'initializing') return '준비 중...';
        if (!total || total <= 0) return '준비 중...';
        const pct = Math.round((current / total) * 100);
        return `${(current || 0).toLocaleString()} / ${total.toLocaleString()}명 (${pct}%)`;
    }

    public get isRebuilding(): boolean {
        return this.rebuildingPK || this.rebuildingStats;
    }

    public ngOnDestroy() {
        this.stopRebuildPKPoll();
        this.stopRebuildStatsPoll();
    }

    // ── 포맷 유틸 ────────────────────────────────────────
    public formatDate(dateStr: string): string {
        if (!dateStr) return '-';
        try {
            const d = new Date(dateStr);
            const y = d.getFullYear();
            const m = String(d.getMonth() + 1).padStart(2, '0');
            const day = String(d.getDate()).padStart(2, '0');
            const h = String(d.getHours()).padStart(2, '0');
            const min = String(d.getMinutes()).padStart(2, '0');
            return `${y}-${m}-${day} ${h}:${min}`;
        } catch {
            return dateStr;
        }
    }

    public statusLabel(status: string): string {
        if (status === 'success') return '성공';
        if (status === 'partial') return '부분 성공';
        if (status === 'error') return '실패';
        return status;
    }

    public statusColor(status: string): string {
        if (status === 'success') return 'text-green-600 bg-green-50';
        if (status === 'partial') return 'text-yellow-600 bg-yellow-50';
        if (status === 'error') return 'text-red-600 bg-red-50';
        return 'text-gray-600 bg-gray-50';
    }

    public dataTypeLabel(dt: string): string {
        if (dt === 'org') return '기관';
        if (dt === 'integrated') return '통합';
        return dt;
    }

    public dataTypeColor(dt: string): string {
        if (dt === 'org') return 'text-indigo-600 bg-indigo-50';
        if (dt === 'integrated') return 'text-teal-600 bg-teal-50';
        return 'text-gray-600 bg-gray-50';
    }

    public formatSize(bytes: number): string {
        if (bytes < 1024) return bytes + ' B';
        if (bytes < 1048576) return (bytes / 1024).toFixed(1) + ' KB';
        return (bytes / 1048576).toFixed(1) + ' MB';
    }

    public formatNumber(n: number): string {
        if (!n) return '0';
        return n.toLocaleString();
    }
}

export default PortalAdminUploadlogComponent;